import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChequeModalComponent} from "./cheque-modal/cheque-modal.component";
import {ChequeComponent} from "./cheque/cheque.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {RouterModule} from "@angular/router";
import {PasswordModalComponent} from "./password-modal/password-modal.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ProfileImageModalComponent} from "./profile-image-modal/profile-image-modal.component";
import {ImageCropperModule} from "ngx-image-cropper";
import {BankModalComponent} from "./bank-modal/bank-modal.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {OfertaModalComponent} from "./oferta-modal/oferta-modal.component";
import {CompraModalComponent} from "./compra-modal/compra-modal.component";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {CotizarDetalleModalComponent} from "./cotizar-detalle-modal/cotizar-detalle-modal.component";
import {RangeDatePickerComponent} from "./range-date-picker/range-date-picker.component";
import {NgbAccordionModule, NgbCollapseModule, NgbDatepickerModule, NgbModalModule, NgbPopoverModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {CustomPipesModule} from "../pipes/custom-pipes.module";
import {SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";
import {OrderModalComponent} from "./order-modal/order-modal.component";
import {CotizarFiltersComponent} from "./cotizar-filters/cotizar-filters.component";
import {ReceiverPopoverComponent} from "./receiver-popover/receiver-popover.component";
import { PortfolioFiltersComponent } from '../pages/portfolio/containers/portfolio-filters/portfolio-filters.component';
import {AvatarModule} from 'ngx-avatars';
import {ClipboardModule} from "ngx-clipboard";
import {OfertaModalPopupComponent} from "./oferta-modal-popup/oferta-modal-popup.component";
import { AssetLinksComponent } from './asset-links/asset-links.component';
import { NosisUserDetailsComponent } from './nosis-user-details/nosis-user-details.component';
import { FinancingRequestDetailsComponent } from './financing-request-details/financing-request-details.component';
import { GenericFieldComponent } from './generic-field/generic-field.component';
import { DocumentViewerDialogComponent } from './document-viewer-dialog/document-viewer-dialog.component';
import { SidebarContentComponent } from './sidebar-content/sidebar-content.component';
import { EndosoModalComponent } from './endoso-modal/endoso-modal.component';
import { TransferidoModalComponent } from './transferido-modal/transferido-modal.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { HugeiconsIconComponent } from '@hugeicons/angular';


@NgModule({
  declarations: [
    ChequeComponent,
    ChequeModalComponent,
    SidebarComponent,
    CotizarFiltersComponent,
    PasswordModalComponent,
    ProfileImageModalComponent,
    BankModalComponent,
    OfertaModalComponent,
    CompraModalComponent,
    CotizarDetalleModalComponent,
    RangeDatePickerComponent,
    OrderModalComponent,
    ReceiverPopoverComponent,
    OfertaModalPopupComponent,
    AssetLinksComponent,
    NosisUserDetailsComponent,
    FinancingRequestDetailsComponent,
    GenericFieldComponent,
    DocumentViewerDialogComponent,
    SidebarContentComponent,
    EndosoModalComponent,
    TransferidoModalComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ImageCropperModule,
        NgSelectModule,
        NgxSliderModule,
        NgbDatepickerModule,
        CustomPipesModule,
        SweetAlert2Module,
        NgbCollapseModule,
        NgxMaskDirective,
        NgbPopoverModule,
        AvatarModule,
        ClipboardModule,
        NgbAccordionModule,
        NgbTooltipModule,
        HugeiconsIconComponent,
        NgbModalModule
    ],
  exports: [
    ChequeComponent,
    SidebarComponent,
    CotizarFiltersComponent,
    RangeDatePickerComponent,
    ReceiverPopoverComponent,
    OfertaModalPopupComponent,
    FinancingRequestDetailsComponent,
    NosisUserDetailsComponent,
    GenericFieldComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class ComponentsModule { }
